<template>
  <MapContainer ref="mapContainer" @statusDrawing='processDrawing' @paletteChange='changePalette'></MapContainer>
    <!-- <div class="row" style="height: 100%; width: 100%">
      <div class="col-md-2 m-0 p-0">
        <ParamView></ParamView>
      </div>
      <div class="col-md-10 m-0 p-0">
        <MapContainer></MapContainer>
      </div>
    </div> -->
</template>

<script>
  import MapContainer from '../map/MapContainer'
  // import ParamView from '../map/ParamView'

  export default {
    name: 'MapView',
    emits: ['statusDrawing2'],
    components: {
      MapContainer,
      // ParamView,
    },
    created: function() {
      try {
        // In production viewMe also refreshes the lidar list; in local mode
        // the users module is a stub without viewMe, so fetch lidars directly.
        if (process.env.VUE_APP_MODE === 'local') {
          this.$store.dispatch('fetchLidars');
        } else {
          this.$store.dispatch('viewMe');
        }
      } catch (error) {
          console.error(error);
      }
      
    },
    activated() {
      this.$nextTick(() => {
        const mc = this.$refs.mapContainer;
        if (mc && mc.map) {
          mc.map.updateSize();
          mc.map.render();
        }
      });
    },
    mounted() {
      document.title = 'LiDAR Web'
    },
    methods: {
      processDrawing (status, progress) {
        this.$emit('statusDrawing2', status, progress)
      },
      changePalette (paletteInfo) {
        this.$emit('paletteChange2', paletteInfo)
      }
    }
  }
</script>

<!-- <style>
  html, body {
    height: 100%;
    margin: 0 auto;
  }

  #app2 {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }
</style> -->
